import { useEffect } from 'react';

import appConfig from 'config';

export default () => {
  const siteKey = appConfig.recaptchaSiteKey;

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.onload = () => {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    // load the script by passing the URL
    loadScriptByURL('recaptcha-key', `https://www.google.com/recaptcha/api.js?render=${siteKey}`, () => {
      console.log('Script loaded!'); // eslint-disable-line no-console
    });
  }, []);

  const getToken = async () => {
    const token = await window.grecaptcha.execute(siteKey, { action: 'submit' });
    return token;
  };

  return { getToken };
};
